export const TP_ACCOUNTS_ROUTE_PATHS = {
  tpAccounts: '/users/tp/accounts',
};

export const TP_ACCOUNTS_API_PATHS = {
  accountAliases: '/v1/api/platform/transfer-platform/accounts/aliases',
  walletById: '/v1/api/platform/wallets',
};

export const CVU_RAIL_ID = 4;

export const IBAN_RAIL_ID = 6;

export const ACCOUNT_TYPE_OPTIONS = [
  { label: 'WALLET', value: '1' },
  { label: 'MERCHANT', value: '2' },
  { label: 'OPERATIONAL', value: '3' },
  { label: 'OPERATIONAL_VIRTUAL', value: '4' },
];

export const RAIL_OPTIONS = [
  { label: 'CVU', value: 4 },
  { label: 'PIX', value: 1 },
  { label: 'BREB', value: 2 },
  { label: 'CRYPTO', value: 5 },
  { label: 'IBAN', value: IBAN_RAIL_ID },
];

export const ACCOUNT_ALIAS_STATUS_OPTIONS = [
  { label: 'ACTIVE', value: 'ACTIVE' },
  { label: 'INACTIVE', value: 'INACTIVE' },
];
